// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Kaa-z","narrowOptionButtons":"Laa-z","noOptions":"Maa-z"};